import {Dispatch} from "redux";
import {Action} from "../actions/toggleActionForEditorActions";
import {ActionType} from "../actionTypes";

export const toggleFlyerDetailsPopup = (isShow: boolean) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.EDITOR_TOGGLE_FLYER_DETAILS_POPUP,
            payload: isShow
        });
    }
}

export const toggleFlyerRightPanel = () => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.EDITOR_TOGGLE_FLYER_RIGHT_PANEL,
        });
    }
}

export const toggleFlyerZoomInModeForFramesPromosScreens = () => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.EDITOR_TOGGLE_ZOOM_IN_MODE_FOR_FRAMES_PROMOS_SCREENS,
        });
    }
}

